module.exports = __webpack_public_path__ + "img/logo_2.0dc7e0ac.png";